import { render, staticRenderFns } from "./U_BaseBusiness_New.vue?vue&type=template&id=13c5dd3e&scoped=true&"
import script from "./U_BaseBusiness_New.vue?vue&type=script&lang=js&"
export * from "./U_BaseBusiness_New.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c5dd3e",
  null
  
)

export default component.exports